<template>
    <div v-if="active">
        <a href="javascript:void(0);" @click="show=true">
            <slot name="link"></slot>
        </a>
        <light-box class="lightbox" v-if="show" @onClose="show=false">
            <slot name="content"></slot>
        </light-box>
    </div>
</template>

<script>
    import Lightbox from './Lightbox';
    import AppSettings from '../AppSettings';

    export default {
        name: "light-box-link",
        components: {Lightbox},
        data() {
            return {
                show: false,
                active: true
            }
        },
        created() {
            this.active = !AppSettings.isMobile;
        }
    }
</script>

<style scoped>
    .lightbox {
        margin: 0;
        padding: 0;
        position: fixed;
        top:0;
        left:0;
    }
</style>
